<template>

<div>
  <div id='main'>
    <div id='content' class='column'>
          <div id="home" >
            
             <div id='contact'>

    <h1>Kontakta oss</h1>
    <h3>Min Trängselskatt är ett ideellt projekt och vi svarar så fort vi hinner!</h3>
    <input type="text" v-model="email" placeholder="Din e-post" /><br>
    <textarea v-model="message" placeholder="Ditt meddelande" ></textarea><br>
    
    <br>

    <button v-on:click="register">SKICKA</button>
    <div class='messageWrapper'>
     <transition name="fade">
    <div class="message" v-if="result.length > 0" @click="result = ''" :style="error ? {'background': 'red'} : {'background': 'green'}"> {{ result }} </div>
    </transition>
    </div>

  </div>


        
      </div>
    </div>

     

  </div>
  
  <!--div id='info' class='section' >
    <div class='column'><h1>Om Min Trängselskatt</h1>...</div>
  </div-->
</div>
</template>

<script>


import validator from './components/mixins/email';

const axios = require('axios');

export default {
  name: 'home',
  components: {

  },

mixins: [validator],
data: function () {
  return {
    email: "",
    message: "",
    result: "",
    error: false
  }
},
    methods: {
        register: async function () {

            if (!this.validateEmail(this.email)){
                this.error = true;
                this.result = "Ogiltig epost";
                return;
            }

            axios.post(this.$hostname + '/contact/', {
            
                        name:this.name,
                        email:this.email,
                        message:this.message,
                      
                    
            })
            .then(response => {

                if (response.data.status == "OK"){

                    this.error = false;
                    this.name = "";
                    this.email = "";
                    this.message = "";
                    this.result = response.data.message;

                    
                }else if (response.data.status == "FAIL"){
                    this.result = response.data.message;
                    this.error = true;
                }else{
                    alert(response.data);
                    this.result = "Kunde inte spara UI";
                    this.error = true;
                }

                
            })
            .catch(error =>  {
                //console.log(error);
                alert("FAIL " + error);
                this.result = "FAIL"
                this.error = true;
                
            });   
        }
     }
     
}



</script>

<style scoped>

div#contact{
  padding:20px;
}
div#contact input{
    margin-bottom:20px;
}

div#contact input[type='text'], textarea{
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    

  font-size:1.2em;
  width: calc(100% - 20px);
  border-radius: 10px;
   border:0px solid transparent;
   padding:10px;
  
}

textarea{
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    height:200px;

}

div#contact button{
    font-size:1.2em;
    border-radius: 10px;
    background-color:#2196f3;
    color:white;
    padding:10px;
    padding-left:20px;
    padding-right:20px;
    border:0px solid transparent;
  
}

.message{
    background-color: rgb(112, 112, 112);
    padding: 10px;
    color:white;
    border-radius: 10px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>

